export default {
  'Enter a promo code! First limit people receive amount coins':
    'Skriv inn promo koden! De første personene mottar en sum mynter',
};
